import { isString } from './isDefined';

export default function removeWhiteSpaces(data) {
  if (!isString(data)) {
    return data;
  }
  return data.replace(/\s/g, '');
}
